
import state from './moduleAlexState.js'
import mutations from './moduleAlexMutations.js'
import actions from './moduleAlexActions.js'
import getters from './moduleAlexGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}